export function toSafeError(unknownError: Error | unknown): Error {
	return unknownError instanceof Error
		? unknownError
		: new Error(`caught non error ${unknownError}`)
}
